import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/betting-guide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/newsletter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/global/top-sportsbooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/news/featured-news.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src264020964/src/client/src/components/primitives/button.tsx");
